import React from 'react';
import { WidgetProps } from '@rjsf/utils';
import { MarkdownContent } from '../markdown-content';
import { Widgets } from '@rjsf/bootstrap-4';

const BootstrapCheckboxesWidget =
  Widgets.CheckboxesWidget as React.ComponentType<any>;

export function CheckboxesWidget({ options, ...props }: WidgetProps) {
  const enumOptions =
    Array.isArray(options.enumOptions) &&
    options.enumOptions.map((option) => {
      return {
        ...option,
        label: (
          <MarkdownContent components={{ p: 'span' }}>
            {option.label}
          </MarkdownContent>
        ),
      };
    });
  return (
    <BootstrapCheckboxesWidget
      {...props}
      options={{
        ...options,
        /* @ts-ignore */
        enumOptions,
      }}
    />
  );
}
